var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "app",
    attrs: {
      "data-app": "app"
    }
  }, [_c('TheOutageCallout'), _c('TheTopNavBar', {
    attrs: {
      "show-my-approval-queue-link": _vm.showMyApprovalQueueLink,
      "has-application-specific-create-menu-items": _vm.hasApplicationSpecificCreateMenuItems,
      "route-configs": _vm.routeConfigs
    },
    on: {
      "show_application_change_log": _vm.emitShowApplicationChangeLog
    }
  }, [_c('template', {
    slot: "create_menu_items"
  }, [_vm._t("create_menu_items")], 2), _c('template', {
    slot: "side_menu_items"
  }, [_vm._t("side_menu_items")], 2), _c('template', {
    slot: "nav_bar_logo"
  }, [_vm._t("nav_bar_logo")], 2), _c('template', {
    slot: "reporting_menu_items"
  }, [_vm._t("reporting_menu_items")], 2), _c('template', {
    slot: "current_user_menu_items"
  }, [_vm._t("current_user_menu_items")], 2)], 2), _c('TheEnvironmentCallout'), _c('main', {
    staticClass: "content pa-2"
  }, [_c('router-view')], 1), _c('c-toaster', {
    domProps: {
      "name": _vm.NOTIFICATION_TOASTER_NAME
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };